export default {
	pageHeader: {
		'margin-left': '5px',
		'margin-top': '5px'
	}
}



// WEBPACK FOOTER //
// ./src/styles/header.js